import { inject, Injectable } from '@angular/core';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';
import { ApplicationsDataDto } from '../types';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';

@Injectable({
  providedIn: 'root',
})
export class ApplicationsInfoService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getApplicationsStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/applications-data').pipe(
      httpRetry(5),
      tap((res: ApplicationsDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
